import * as Yup from 'yup';

export const emailValidation = Yup.string()
  .email('Invalid email address')
  .max(80, 'Email address must be less than 80 characters')
  .min(1, 'Email is required');
